module.exports = __webpack_public_path__ + "static/media/poste_12.3684996e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_12.jpg
// module id = 240
// module chunks = 0